import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { NoInfer } from "react-redux";
import {
  MemberStateType,
  MessageMemberResponseType,
  PromotionMemberResponseType,
  VipMemberResponseType,
} from "types/member";

import {
  getMessageMember,
  getPromotionMember,
  getVipMember,
} from "./member.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<MemberStateType>>
) => {
  builder
    .addCase(getMessageMember.pending, (state: MemberStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getMessageMember.fulfilled,
      (
        state: MemberStateType,
        action: PayloadAction<MessageMemberResponseType>
      ) => {
        state.isLoading = false;
        state.dataMessageMember = { ...action.payload };
      }
    )
    .addCase(getPromotionMember.pending, (state: MemberStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getPromotionMember.fulfilled,
      (
        state: MemberStateType,
        action: PayloadAction<PromotionMemberResponseType>
      ) => {
        state.isLoading = false;
        state.dataPromotionMember = { ...action.payload };
      }
    )
    .addCase(getVipMember.pending, (state: MemberStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getVipMember.fulfilled,
      (
        state: MemberStateType,
        action: PayloadAction<VipMemberResponseType>
      ) => {
        state.isLoading = false;
        state.dataVipMember.data = { ...action.payload.data };
      }
    );
};
